import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { getUiState } from "../../../store";
import { categoryPrvSliceActions, setCategoryActive } from "../../../store/slices/categorySlice";
import { enableScrollScreen, showSidebarModal } from "../../../store/slices/uiSlice";
import { ICategory } from "../../../types/category";
export default function Sidebar() {
    const [categories, setCatgories] = useState<any>();
    const dispatch = useAppDispatch();
    const { isShowSidebar } = useAppSelector(getUiState)
    const [tabActive, setTabActive] = useState<number>(0);
    useEffect(() => {
        const fetchCategories = async () => {
            const res = await dispatch(categoryPrvSliceActions.getCategoryList());
            setCatgories((prev: any) => prev = res.payload)
        }
        fetchCategories()
    }, [dispatch])
    return (
        <div className={isShowSidebar
            ? "w-full z-50 rounded-sm max-md:fixed max-md:top-0 max-md:left-0 max-md:h-screen max-md:flex"
            : "w-full rounded-sm max-md:hidden"}
        >
            <div className="sticky top-6 w-full max-md:flex">
                <div className="max-md:w-3/4 max-md:shadow-lg max-md:shadow-gray-300 max-md:bg-white rounded max-md:rounded-none overflow-hidden">
                    <h3 className="font-medium p-3 text-lg border-b-[1px] border-solid border-[#eeeff0] bg-white">Danh mục sản phẩm</h3>
                    <div className="flex flex-col items-start justify-start gap-1 p-2 text-[#182537] bg-white max-md:overflow-y-auto max-md:h-full max-md:pb-6">
                        <button
                            className={tabActive === 0 ?
                                "text-sm font-normal px-2 py-[6px] text-left w-full text-[#0088FF] bg-[#e6f4ff] rounded hover:text-[#0088FF] hover:bg-[#e6f4ff]" :
                                "text-sm font-normal px-2 py-[6px] text-left w-full  rounded hover:text-[#0088FF] hover:bg-[#e6f4ff]"
                            }
                            onClick={() => {
                                dispatch(setCategoryActive({ categoryId: 0, categoryName: "Tất cả sản phẩm" }));
                                dispatch(showSidebarModal());
                                dispatch(enableScrollScreen());
                                setTabActive(prev => prev = 0)

                            }}
                        >
                            Tất cả sản phẩm
                        </button>
                        {categories?.map((category: ICategory) => (
                            <button
                                key={category.id}
                                onClick={() => {
                                    dispatch(showSidebarModal());
                                    setTabActive(prev => prev = category.id);
                                    dispatch(enableScrollScreen());
                                    dispatch(setCategoryActive({ categoryId: category.id, categoryName: category.name }));
                                }}
                                className={tabActive === category.id ?
                                    "text-sm font-normal px-2 py-[6px] text-left w-full text-[#0088FF] bg-[#e6f4ff] rounded hover:text-[#0088FF] hover:bg-[#e6f4ff] uppercase" :
                                    "text-sm font-normal px-2 py-[6px] text-left w-full  rounded hover:text-[#0088FF] hover:bg-[#e6f4ff] uppercase"
                                }
                            >
                                {category.name}
                            </button>
                        ))}
                    </div>
                </div>
                {isShowSidebar && <div className="hidden max-md:block h-screen bg-black opacity-50 flex-1 z-0"
                    onClick={() => {
                        dispatch(showSidebarModal());
                        dispatch(enableScrollScreen());
                    }}>
                </div>}
            </div>
        </div >
    );
}